// src/auth/hooks.ts
import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../supabase';
export function useSession() {
    const [session, setSession] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let mounted = true;
        supabase.auth.getSession().then(({ data }) => {
            if (!mounted)
                return;
            setSession(data.session ?? null);
            setLoading(false);
        });
        const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setSession(s));
        return () => { mounted = false; sub.subscription.unsubscribe(); };
    }, []);
    return { session, user: session?.user ?? null, loading };
}
export const signIn = (email, password) => supabase.auth.signInWithPassword({ email, password });
export const signUp = (email, password) => supabase.auth.signUp({ email, password });
export const signOut = () => supabase.auth.signOut();
export function useSignOut() {
    return useCallback(async () => {
        await supabase.auth.signOut();
        window.location.href = '/';
    }, []);
}
